import { ProjectStructureType } from "@/web-client/api";

const formatStructureType = (value: ProjectStructureType): string => {
  switch (value) {
    case ProjectStructureType.WOODEN:
      return "木造";

    case ProjectStructureType.STEEL:
      return "鉄骨造";

    case ProjectStructureType.REINFORCED_CONCRETE:
      return "鉄筋コンクリート造";

    case ProjectStructureType.STEEL_REINFORCED_CONCRETE:
      return "鉄骨鉄筋コンクリート造";

    case ProjectStructureType.MASONRY:
      return "組積造";

    case ProjectStructureType.MIX:
      return "混構造";

    case ProjectStructureType.OTHER:
      return "その他構造";
  }
};
export default formatStructureType;
